import $ from "jquery"
window.$ = window.jQuery = $

import "jquery-ujs"

import "../stylesheets/platform.scss"
import "../stylesheets/platform_additional.scss"
import "platform_controllers"

import { Chart } from "chart.js"
import "chartkick/chart.js"
window.Chart = Chart
